
<section class="latest_static_card">
    <div class="row" *ngIf="course_id">
        <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let course of courses">
            <div class="card">
                <div class="card-content">
                    <div class="card-image">
                        <img class="card-img-top img-fluid" src="assets/course-img.png" alt="Card image cap">
                        <div class="card_content_title position_to_be_absolute">
                            <h6>{{course?.title}}</h6>
                        </div>
                    </div>
                        <div class="card-body">
                            <div class="price_full_radius">
                                <a>{{course?.total_fees | currency:'INR'}}</a>
                            </div>
                            <div class="card_content_main">
                                <p>{{course?.course_category[0]?.displayname}}</p>
                            </div>
                            <div class="card_content_title">
                                <h6>{{course?.title}}</h6>
                            </div>
                            <div class="card_content_rating">
                                <div class="rating_stars">
                                    <i class="ft-star-on"></i>
                                    <i class="ft-star-on"></i>
                                    <i class="ft-star-on"></i>
                                    <i class="ft-star-on"></i>
                                    <i class="ft-star-on"></i>
                                </div>
                                <div class="rating_count">
                                    <span>(0/5 Ratings)</span>
                                </div>
                            </div>
                            <div class="card_course_name">
                              <p>{{course?.about|slice:0:125}}...</p>
                            </div>
                            <div class="card_course_meta">
                              <ul>                              
                              <li class="mr-15px"><i class="ft-list"></i> English</li>
                                <li> <i class="ft-user"></i> <span>Online</span></li>
                              </ul>
                            </div>
                            <div class="custom_button_card">
                              <button class="btn btn-primary" [routerLink]="['learn-by-course',course?.slug]">Learn</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let course of default_courses"> 
            <div class="card">
                <div class="card-content">
                    <div class="card-image">
                        <img class="card-img-top img-fluid" src="assets/course-img.png" alt="Card image cap">
                        <div class="card_content_title position_to_be_absolute">
                            <h6>{{course?.title}}</h6>
                        </div>
                    </div>
                        <div class="card-body">
                            <div class="price_full_radius">
                                <a>{{course?.total_fees | currency:'INR'}}</a>
                            </div>
                            <div class="card_content_main">
                                <p>{{course?.course_category[0]?.displayname}}</p>
                            </div>
                            <div class="card_content_title">
                                <h6>{{course?.title}}</h6>
                            </div>
                            <div class="card_content_rating">
                                <div class="rating_stars">
                                    <i class="ft-star-on"></i>
                                    <i class="ft-star-on"></i>
                                    <i class="ft-star-on"></i>
                                    <i class="ft-star-on"></i>
                                    <i class="ft-star-on"></i>
                                </div>
                                <div class="rating_count">
                                    <span>(0/5 Ratings)</span>
                                </div>
                            </div>
                            <div class="card_course_name">
                              <p [innerHTML]="course?.about|slice:0:125"></p>
                            </div>
                            <div class="card_course_meta">
                              <ul>                              
                              <li class="mr-15px"><i class="ft-list"></i> English</li>
                                <li> <i class="ft-user"></i> <span>Online</span></li>
                              </ul>
                            </div>
                            <div class="custom_button_card">
                              <button class="btn btn-primary" [routerLink]="['learn-by-course',course?.slug]">Learn</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12"> 
            <div class="card">
                <div class="card-content">
                    <div class="card-image">
                        <img class="card-img-top img-fluid" src="assets/course-img.png" alt="Card image cap">
                        <div class="card_content_title position_to_be_absolute">
                            <h6>Enrollment Detail</h6>
                        </div>
                    </div>
                        <div class="card-body">
                            <div class="card_content_title">
                                <h6>Check your enrollment details</h6>
                            </div>
                            <div class="custom_button_card">
                              <button class="btn btn-primary" [routerLink]="['/student-enrollment',enrollment[0]?.enrolment?._id]">Goto Detail</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="d-flex justify-content-between align-items-center">
        <ngx-spinner></ngx-spinner>
    </div>
